import React, { Component } from 'react';
import { DatePicker, Input, Select } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import debounce from 'lodash/debounce';

import './FilterGroup.scss';

const { RangePicker } = DatePicker;
const Option = Select.Option;
const Search = Input.Search;

export class FilterGroup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filters: {},
            searchText: ''
        }

        this.handleSearch = debounce(this.handleSearch, 500);
    }

    handleSearch(value) {
        const { onChange } = this.props;
        const { filters } = this.state;

        this.setState({ searchText: value });
        onChange(filters, value)
    }

    handleSearchChange(e) {
        this.handleSearch(e.target.value)
    }

    componentDidUpdate(prevProps, prevState) {
        const { filterList, onChange } = this.props;
        const { filters, searchText } = this.state

        if (!_.isEqual(prevProps.filterList, filterList)) {
            this.setState({ filters: {} });
        }

        if (!_.isEqual(prevState.filters, filters)) {
            onChange(filters, searchText);
        }
    }

    render() {
        const { filterList, disabled } = this.props;
        const { filters } = this.state;
        const isFilterEmpty = filterList.length === 0;

        return (
            <div className="FilterGroup">
                {
                    _.map(filterList, (filter) => {
                        switch (filter.type) {
                            case 'select':
                                const options = _.map(filter.options, (option) => (<Option key={`${filter.name}-${option.value}`} value={option.value}>{option.label}</Option>));
                                return (
                                    <Select
                                        className="filter-group-filter"
                                        key={filter.name}
                                        placeholder={filter.placeholder} 
                                        dropdownMatchSelectWidth={false} 
                                        allowClear
                                        value={filters[filter.name]}
                                        onChange={(value) => this.setState({ filters: { ...filters, [filter.name]: value } })}
                                        disabled={disabled}
                                    >
                                        {options}
                                    </Select>
                                );
                            case 'dateRange':
                                return (
                                    <RangePicker
                                        className="filter-group-filter"
                                        key={filter.name}
                                        placeholder={filter.placeholder} 
                                        value={[
                                            filters[filter.name + '_start'] ? moment(filters[filter.name + '_start']) : undefined, 
                                            filters[filter.name + '_end'] ? moment(filters[filter.name + '_end']) : undefined
                                        ]}
                                        onChange={(value) => this.setState({ 
                                            filters: { 
                                                ...filters, 
                                                [filter.name + '_start']: value[0] ? value[0].startOf('day').toISOString() : undefined, 
                                                [filter.name + '_end']: value[1] ? value[1].endOf('day').toISOString() : undefined 
                                            }
                                        })}
                                        disabled={disabled}
                                    />
                                );
                            default:
                                return;
                        }
                    })
                }
                <Search 
                    style={{ marginLeft: isFilterEmpty ? 0 : 7.5 }}
                    placeholder="Search" 
                    onChange={(e) => this.handleSearchChange(e)}
                    disabled={disabled}
                />
            </div>
        );
    }
}

FilterGroup.defaultProps = {
    filterList: [],
    onChange: () => {}
}

export default FilterGroup;


// WEBPACK FOOTER //
// ./src/components/FilterGroup/FilterGroup.js